import OpenSeaDragon from "openseadragon";
import React, { useEffect, useState } from "react";

const OpenSeaDragonViewer = ({ image,title }) => {
var tileSource = `${window.location.origin}/Json_images_low/${title}.dzi`;
  const [viewer, setViewer] = useState( null);
useEffect(() => {
    if (image && viewer) {
      viewer.open(image.source);
    }
  }, [image]);
const InitOpenseadragon = () => {
    viewer && viewer.destroy();
    setViewer(
      OpenSeaDragon({
        id: "contentDiv",
        prefixUrl: "openseadragon-images/",
        tileSources: tileSource,
        maxZoomPixelRatio: Infinity
      })
    );
  };
useEffect(() => {
    InitOpenseadragon();
    return () => {
        viewer && viewer.destroy();
    };
  }, []);
return (
  <div 
  id="contentDiv" 
  style={{
    height: "80vh",
    maxHeight: "80%",
    maxWidth: "100%",
  }}
  >
  </div>
  );
};
export { OpenSeaDragonViewer };